<template>
  <div class="spinner">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: 'spinner',

}
</script>
<style scoped>
.spinner {
  z-index: 1;
  position: fixed;
  top:0;
  bottom:0;
  left:0;
  right: 0;
  display:flex;
  align-items: center;
  justify-content: center;
  background-color: #f6f3f0;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid #ddd;
  border-right: 1.1em solid #ddd;
  border-bottom: 1.1em solid #ddd;
  border-left: 1.1em solid #F7921E;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>
